import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const forGotPassWordApi = (data) =>
    Promise.resolve(axios.post(endpoints.forGotPassWord, data));
